// extracted by mini-css-extract-plugin
module.exports = {"booking_info":"Service_booking_info__eym0p","heading":"Service_heading__1wYVR","packages":"Service_packages__1ZxSf"};